// src/redux/deploymentSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchWrapper } from "../utils/fetchWrapper";

export const runDeployment = createAsyncThunk(
    "deployment/run",
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await fetchWrapper.post(
                "setting/run-script",
                {},
                { withCredentials: true }
            );

            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

const deploymentSlice = createSlice({
    name: "deployment",
    initialState: {
        isRunning: false,
        loading: false,
        error: null,
        success: null,
        lastDeployment: null,
    },
    reducers: {
        clearDeploymentStatus: (state) => {
            state.error = null;
            state.success = null;
        },
        setRunning: (state, action) => {
            state.isRunning = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(runDeployment.pending, (state) => {
                state.loading = true;
                state.isRunning = true;
                state.error = null;
                state.success = null;
            })
            .addCase(runDeployment.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.success = payload.message;
                state.lastDeployment = {
                    timestamp: payload.timestamp,
                    totalStages: payload.totalStages,
                };
            })
            .addCase(runDeployment.rejected, (state, { payload }) => {
                state.loading = false;
                state.isRunning = false;
                state.error = payload;
            });
    },
});

export const { clearDeploymentStatus, setRunning } = deploymentSlice.actions;
export default deploymentSlice.reducer;
